module.exports = __webpack_public_path__ + "static/media/24c35b07-f9c3-4de9-a509-cc4191fc7122.075964fc.png";